export default __webpack_public_path__ + "static/media/291.43fc69d4.png";